import './index.css'

import React from 'react'
import imageRecommendationsPng from 'assets/images/image-recommendations.png'
import AspectRatio from 'components/ui/aspect-ratio'
import Heading from 'components/ui/heading'
import ModalWindow from 'components/ui/modal-window'

const ImageRecommendationsModal = ({
  onClose,
}: {
  onClose: (...args: Array<any>) => any
}): React.ReactNode => {
  return (
    <ModalWindow
      width="medium"
      onClose={onClose}
      header={<Heading size={600}>Image recommendations</Heading>}
      isOpen
    >
      <div className="ImageRecommendationsModal_ImageContainer">
        <AspectRatio image={imageRecommendationsPng} ratio={1.6} />
        <div className="ImageRecommendationsModal_ImageCaptionContainer">
          <div className="ImageRecommendationsModal_ImageCaption">
            Make sure the key part of your image (e.g. faces) is in the top two
            thirds of your image
          </div>
        </div>
      </div>
      <ul className="ImageRecommendationsModal_List">
        <li>File format: jpeg or png</li>
        <li>Header images must be landscape and at least 2000px wide</li>
      </ul>
      <div className="ImageRecommendationsModal_Text">
        Get more tips from our{' '}
        <a
          className="text-link"
          href="https://support.disco.ac/home/catalogs-guide#recommended-image-specifications-for-disco-catalogs-artist-pages-and-album-pages"
          target="_blank"
          rel="noopener noreferrer"
        >
          FAQs
        </a>
      </div>
    </ModalWindow>
  )
}

export default ImageRecommendationsModal
